<!-- =========================================================================================
    File Name: Profile.vue
    Description: Profile Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="profile-page" ref="profile_page">
    <vs-button class="mb-3" icon-pack="feather" icon="icon-arrow-left" type="border" color="success" @click="$router.back()" style="border-radius: 30px !important">Back</vs-button>
    <vx-card id="userInfoCard" ref="userInfo" title="User Info">
      <vs-divider>General Information</vs-divider>
      <div class="vx-row pb-3">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label>Email</label>
          <vs-input autocomplete="off" icon-no-border ref="emailInput" class="w-full" icon-pack="feather" icon="icon-at-sign" v-model="formData.email" />
        </div>
      </div>
      <div class="vx-row pb-3">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label>First Name</label>
          <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required|alpha_spaces'" name="First Name" icon-pack="feather" icon="icon-user" v-model="formData.userFirstName" />
          <span class="text-danger text-sm" v-show="errors.has('First Name')">{{ errors.first('First Name') }}</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label>Last Name</label>
          <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required|alpha_spaces'" name="Last Name" icon-pack="feather" icon="icon-user" v-model="formData.userLastName" />
          <span class="text-danger text-sm" v-show="errors.has('Last Name')">{{ errors.first('Last Name') }}</span>
        </div>
      </div>
      <div class="vx-row pb-3">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label>Work Phone</label>
          <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'numeric'" name="Work Phone" icon-pack="feather" icon="icon-phone" v-model="formData.work" />
          <span class="text-danger text-sm" v-show="errors.has('Work Phone')">{{ errors.first('Work Phone') }}</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label>Mobile</label>
          <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required|numeric'" name="Mobile" icon-pack="feather" icon="icon-smartphone" v-model="formData.mobile" />
          <span class="text-danger text-sm" v-show="errors.has('Mobile')">{{ errors.first('Mobile') }}</span>
        </div>
      </div>
      <div class="vx-row pb-3">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label>Identification Number or Passport Number</label>
          <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full"  name="Identification Number" icon-pack="feather" icon="icon-hash" v-model="formData.idNumber" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2" v-if="allowRegNum">
          <label>Registration Number</label>
          <vs-input autocomplete="off" icon-no-border onClick="this.select();" class="w-full" v-validate="'required'" name="Registration Number" icon-pack="feather" icon="icon-user-check" v-model="formData.registrationNumber" />
          <span class="text-danger text-sm" v-show="errors.has('Registration Number')">{{ errors.first('Registration Number') }}</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <vs-checkbox v-model="formData.emailNotificationsEnabled">Receive Email Notifications</vs-checkbox>
        </div>
      </div>
      <vs-divider class="mb-6 pt-0">Profile Picture</vs-divider>
      <div class="vx-col xl:w-1/6 mx-auto pt-2 self-center">
        <img sizes="100px" :src="formData.uploadedFileName" v-show="formData.uploadedFileName" @click="showUpload" width="100%" class="cursor-pointer">
        <div class="flex flex-wrap items-center justify-center pb-4">
          <file-pond id="filepond"
            v-show="!formData.uploadedFileName"
            ref="pond"
            :server="uploadLocation"
            label-idle="Drop document here or <span class='filepond--label-action'>Browse</span>"
            :allow-multiple="false"
            accepted-file-types="jpeg,jpg,png"
            :instant-upload="true"
            allowPaste=false
            :allow-image-preview="true"
            @processfile="uploadComplete"
            @removefile="fileRemoved" />
        </div>
      </div>
      <vs-divider class="mb-6 pt-0">Signature</vs-divider>
      <div class="vx-col cropper-div">
        <input
          ref="input"
          type="file"
          name="image"
          accept="image/*"
          @change="setImage"
        />
        <section class="cropper-area_tool">
          <div class="img-cropper">
            <vue-cropper
              v-show="formData.signatureImageUrl"
              ref="cropper"
              :src="formData.signatureImageUrl"
              preview=".preview"
            />
          </div>
        </section>
        <div class="vx-vol cropper-area_buttons">
          <div class="vx-row ml-0">
            <vs-button class="mr-5 mt-3 new-signature-button-on-select" color="success" type="filled" icon-pack="feather" icon="icon-upload" @click.prevent="showFileChooser">Upload New Signature</vs-button>

            <vs-button v-show="newSignatureClicked" class="mr-5 mt-3" type="border" color="warning" icon-pack="feather" icon="icon-refresh-ccw" @click.prevent="reset">Reset</vs-button>

            <vs-button v-show="newSignatureClicked" radius class="mr-2 mt-3" icon-pack="feather" icon="icon-zoom-in" @click.prevent="zoom(0.2)" />
            <vs-button v-show="newSignatureClicked" radius class="mr-5 mt-3" icon-pack="feather" icon="icon-zoom-out" @click.prevent="zoom(-0.2)" />

            <vs-button v-show="newSignatureClicked" radius type="border" class="mr-2 mt-3" icon-pack="feather" icon="icon-arrow-left" @click.prevent="move(-10, 0)" />
            <vs-button v-show="newSignatureClicked" radius type="border" class="mr-2 mt-3" icon-pack="feather" icon="icon-arrow-right" @click.prevent="move(10, 0)" />
            <vs-button v-show="newSignatureClicked" radius type="border" class="mr-2 mt-3" icon-pack="feather" icon="icon-arrow-up" @click.prevent="move(0, -10)" />
            <vs-button v-show="newSignatureClicked" radius type="border" class="mr-5 mt-3" icon-pack="feather" icon="icon-arrow-down" @click.prevent="move(0, 10)" />

            <vs-button v-show="newSignatureClicked" radius class="mr-2 mt-3" icon-pack="feather" icon="icon-rotate-cw" @click.prevent="rotate(90)" />
            <vs-button v-show="newSignatureClicked" radius class="mr-5 mt-3" icon-pack="feather" icon="icon-rotate-ccw" @click.prevent="rotate(-90)" />

            <vs-button v-show="newSignatureClicked" class="mr-5 mt-3" color="success" icon-pack="feather" icon="icon-crop" @click.prevent="cropImage">Crop</vs-button>
          </div>
        </div>
        <p v-show="cropImg" class="mt-3 text-success">Signature cropped. Remember to click <strong>Save</strong>.</p>
      </div>
      <div v-show="canChangePassword">
        <vs-divider class="mb-6 pt-0">Login Credentials</vs-divider>
        <div class="vx-row pb-3" v-show="!isChangePasswordHidden">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-checkbox v-model="changePassword">Change Password</vs-checkbox>
          </div>
        </div>
        <div class="vx-row pb-3" v-show="changePassword">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input style="display: none;"/>
            <label>Password</label>
            <div style="display: flex;">
              <vs-input id="passBox" autocomplete="off" icon-no-border onClick="this.select();" type="password" v-validate="'min:8|max:100'" name="password" ref="password" class="w-full" icon-pack="feather" icon="icon-lock" v-model="formData.password" />
              <feather-icon @mouseover="showPassword('passBox')" @mouseout="hidePassword('passBox')" icon="EyeIcon" class="cursor-pointer ml-3"></feather-icon>
            </div>
            <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
          </div>
        </div>
        <div class="vx-row pb-3" v-show="changePassword">
          <div class="vx-col sm:w-1/2 w-full mb-2" v-show="formData.password" >
            <label>Confirm Password</label>
            <div style="display: flex;">
              <vs-input id="confPassBox" autocomplete="off" icon-no-border onClick="this.select();" type="password" v-validate="'min:8|max:100|confirmed:password'" name="confirm_password" data-vv-as="password" class="w-full" icon-pack="feather" icon="icon-lock" v-model="formData.passwordConfirm" />
              <feather-icon @mouseover="showPassword('confPassBox')" @mouseout="hidePassword('confPassBox')" icon="EyeIcon" class="cursor-pointer ml-3"></feather-icon>
            </div>
            <span class="text-danger text-sm" v-show="errors.has('confirm_password')">{{ errors.first('confirm_password') }}</span>
          </div>
        </div>
      </div>
      <vs-divider class="mb-6 pt-0">Roles</vs-divider>
      <div class="vx-row pb-3" :key="index" v-for="(role,index) in formData.roles.filter(x => x.isSelected)">
        <div class="vx-col mb-2">
          <vs-checkbox :disabled="true" :value="role.isSelected" v-model="role.isSelected">{{role.text}}</vs-checkbox>
        </div>
      </div>

      <vs-divider class="mb-6 pt-0"></vs-divider>
      
      <div class="vx-row">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" @click.prevent="saveEditUser" ref="saveEditButton">Save</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
export default {
  components: {
    FilePond,
    VueCropper
  },
  data() {
    return {
      formData: {
        id: 0,
        userFirstName: "",
        userLastName: "",
        work: "",
        mobile: "",
        email: "",
        password: null,
        passwordConfirm: null,
        isActive: false,
        roles: [],
        site: [],
        uploadedFileName: "",
        idNumber: "",
        registrationNumber: "",
        signatureImageUrl: "",
        emailNotificationsEnabled: false
      },
      allowRegNum: false,
      changePassword: false,
      canChangePassword: false,
      isChangePasswordHidden: false,
      cropImg: null,
      newSignatureClicked: false,
      originalEmail: null,
      wasSidebarOpen: false
    };
  },
  computed: {
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    },
  },
  watch: {
    formData: {
      deep: true,
      handler() {
        var self = this;
        if(self.formData.roles.filter(function(item) { return item.isSelected && (item.text == "Assessor" || item.text == "Moderator") }).length > 0){
          self.allowRegNum = true;
        }else{
          self.allowRegNum = false;
        }
      }
    }
  },
  methods: {
    uploadComplete(error, file) {
      var response = JSON.parse(file.serverId);
      if(response.url)
        this.formData.uploadedFileName = response.url;
    },
    fileRemoved(error, file) {
      this.formData.uploadedFileName = "";
    },
    showUpload() {
      this.formData.uploadedFileName = null;
    },
    getCurrentUser() {
      var self = this;
      self.scrollToNavbar('navbarGlobal');

      self.showLoadingOnElement("profile_page", 1, "material");

      var onSuccess = function (response) {
        self.populateUserData(response.data);
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.profile_page.$el);
      };

      self.$ajaxGet(self, "User/GetBackendUserInfo", onSuccess, onFinally);
    },
    populateUserData(user) {
      this.canChangePassword = true;
      this.isChangePasswordHidden = false;
      this.changePassword = false;
      this.formData.id = user.id;
      this.formData.userFirstName = user.userFirstName;
      this.formData.userLastName = user.userLastName;
      this.formData.work = user.work;
      this.formData.mobile = user.mobile;
      this.formData.uploadedFileName = user.imageUrl;
      this.formData.email = user.email;
      this.originalEmail = user.email;
      this.formData.isActive = user.isActive;
      this.formData.idNumber = user.idNumber;
      this.formData.registrationNumber = user.registrationNumber;
      if (this.$siteTypeId() == 1) {
        this.formData.roles = user.roles;
      } else {
        this.formData.roles = user.roles.filter(function(item) {return item.id != 14 && item.id != 15});
      }
      this.formData.signatureImageUrl = user.signatureImageUrl;
      this.formData.emailNotificationsEnabled = user.emailNotificationsEnabled;

      if(JSON.parse(localStorage.getItem('userSiteInfo'))[0]){
        this.formData.site = JSON.parse(localStorage.getItem('userSiteInfo'))[0];
      }else{
        this.formData.site = JSON.parse(localStorage.getItem('userSiteInfo'));
      }
    },
    cropImage() {
      var self = this;
      self.cropImg = self.$refs.cropper.getCroppedCanvas().toDataURL();

      self.showLoadingOnElement("saveEditButton", 0.45, "material");

      var fileExt = self.cropImg.substring(
        self.cropImg.indexOf("/") + 1, 
        self.cropImg.indexOf(";")
      );

      var byteString = atob(self.cropImg.split(',')[1]);
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);

      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      var blob = new Blob([ab], { type: 'image/' + fileExt });
      
      var data = new FormData();
      data.append('image', blob, "signature_" + self.formData.id + "." + fileExt);

      var onSuccess = response => {
        self.formData.signatureImageUrl = response.data.url;
      };

      var onFinally = function () {
        self.$vs.loading.close(self.$refs.saveEditButton.$el);
      };

      self.$ajaxPost(self, "tempupload", data, onSuccess, onFinally);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    reset() {
      this.cropImg = null;
      this.$refs.cropper.reset();
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    setImage(e) {
      const file = e.target.files[0];
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.formData.signatureImageUrl = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
        this.newSignatureClicked = true;
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    showFileChooser() {
      this.$refs.input.click();
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    showPassword(elementId) {
      document.getElementById(elementId).removeAttribute("type");
    },
    hidePassword(elementId) {
      document.getElementById(elementId).setAttribute("type", "password");
    },
    saveEditUser() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          self.showLoadingOnElement("saveEditButton", 0.45, "material");
          self.formData.email = self.formData.email.toLowerCase();

          var onSuccess = response => {
            self.scrollToNavbar('navbarGlobal');
            self.cropImg = null;
            self.newSignatureClicked = false;
            self.$refs.cropper.destroy();
            self.getCurrentUser();
            self.$vs.notify({
              title:'Information',
              color: "success",
              text: "Details Updated",
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-save'
            });

            if (self.originalEmail != self.formData.email) {
              self.logout();
            }
          };
          var onFinally = function () {
            self.$vs.loading.close(self.$refs.saveEditButton.$el);
          };
          
          self.$ajaxPost(self, "user/addedituser", self.formData, onSuccess, onFinally);
        } else {
          self.$vs.notify({
            title:'Attention',
            color: "warning",
            text: self.$validator.errors.items[0].msg,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-info'
          });
        }
      });
    },
    logout() {
      this.$endUserSession();
      
      let routeData = this.$router.resolve({ path: '/login' });
      window.open(routeData.href, '_self');
      
      this.$acl.change("");
      localStorage.setItem("permissions", "");
      localStorage.setItem("userSiteInfo", "");
      localStorage.setItem("isStudent", "false");
    },
    showLoadingOnElement(element, scale, type){
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    scrollToNavbar(elementId) {
      var scrollOptions = {
        easing: 'ease-in',
        offset: -500,
        force: true,
        cancelable: true,
        x: false,
        y: true
      }
      var cancelScroll = this.$scrollTo(document.getElementById(elementId), 500, scrollOptions);
    },
  },
  mounted() {
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    this.getCurrentUser();
  },
  beforeDestroy() {
    if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  }
};
</script>

<style lang="scss">
.new-signature-button-on-select{
  height: fit-content;
  margin-top: 14px;
  margin-right: 2px;
}

.cropper-div {
  input[type="file"] {
    display: none;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 5px 0;
  }
  .header h2 {
    margin: 0;
  }
  .header a {
    text-decoration: none;
    color: black;
  }
  .cropper-area_tool {
    width: 60%;
  }
  .cropper-area_buttons {
    width: 100%;
  }
  .actions {
    margin-top: 1rem;
    display: flex;
  }
  textarea {
    width: 100%;
    height: 100px;
  }
  .preview-area {
    width: 307px;
  }
  .preview-area p {
    font-size: 1.25rem;
    margin: 0;
    margin-bottom: 1rem;
  }
  .preview-area p:last-of-type {
    margin-top: 1rem;
  }
  .preview {
    width: 100%;
    height: calc(372px * (9 / 16));
    overflow: hidden;
  }
  .crop-placeholder {
    width: 100%;
    height: 200px;
    background: #ccc;
  }
  .cropped-image img {
    max-width: 100%;
  }
}
</style>